export function startsWith(a: string, b: string): boolean {
  return a.toLowerCase().startsWith(b.toLowerCase());
}
